import { gql, TypedDocumentNode, useMutation } from '@apollo/client';
import { accountsQuery } from './use-accounts';
import { DeleteAccountMutation, DeleteAccountMutationVariables } from '../../generated/graphql';

export const deleteAccountMutation: TypedDocumentNode<DeleteAccountMutation, DeleteAccountMutationVariables> = gql`
  mutation DeleteAccount($email: String!) {
    deleteAccount(email: $email) {
      deleted
    }
  }
`;

type DeleteAccount = (email: string) => Promise<boolean>;

export function useDeleteAccount(): DeleteAccount {
  const [update] = useMutation(deleteAccountMutation);

  return async (email) => {
    const { data, errors } = await update({
      variables: {
        email,
      },
      update(cache, response) {
        // Update list of accounts to remove the account
        const existingData = cache.readQuery({ query: accountsQuery });
        if (existingData && response.data?.deleteAccount.deleted) {
          cache.writeQuery({
            query: accountsQuery,
            data: {
              accounts: existingData.accounts.filter((account) => account.email !== email),
            },
          });
        }
      },
    });

    if (errors?.length) {
      throw errors[0];
    }

    if (!data) {
      // Should not happen: https://github.com/apollographql/apollo-client/issues/6374
      throw new Error('Expected data, nothing received.');
    }

    return data.deleteAccount.deleted;
  };
}
